/* BSCAM: product titles never break at a hyphen ("T-Shirt", "Zip-Up" stay together).
   Wraps hyphenated words inside product titles in <span class="bscam-nowrap">.
   Covers product pages, product cards, homepage rows, cart page and cart drawer. */
(function () {
  var SEL = '.product__title h1, .product__title h2, .card__heading, .cart-item__name, ' +
            '[class*="product-title-"], [class*="__product-title-"]';
  var WORD = /(\S*\S-\S\S*)/;
  function fix() {
    document.querySelectorAll(SEL).forEach(function (el) {
      var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
      var nodes = [], n;
      while ((n = walker.nextNode())) {
        var p = n.parentNode;
        if (WORD.test(n.nodeValue) && !(p.classList && p.classList.contains('bscam-nowrap'))) nodes.push(n);
      }
      nodes.forEach(function (t) {
        var frag = document.createDocumentFragment();
        t.nodeValue.split(WORD).forEach(function (part, i) {
          if (!part) return;
          if (i % 2) {
            var s = document.createElement('span');
            s.className = 'bscam-nowrap';
            s.textContent = part;
            frag.appendChild(s);
          } else {
            frag.appendChild(document.createTextNode(part));
          }
        });
        t.parentNode.replaceChild(frag, t);
      });
    });
  }
  var queued = false;
  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; fix(); });
  }
  function init() {
    fix();
    new MutationObserver(queue).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
